import { TabItem } from '@vyce/core/src/types';

export const EMPLOYEE_PAYROLL_TABS: TabItem[] = [
  {
    label: 'Timesheets',
    link: '/payroll/timesheets',
  },
];
